<template>
  <div>
    <v-dialog v-model="loading" persistent width="500">
      <v-card color="primary" dark>
        <v-card-text>
          Loading...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-card flat>
      <UtillityServiceQualificationForm
        ref="qualificationForm"
        :speed="speed"
        @showResultSection="showResultSection"
        @toggleInput="toggleInput"
        @changed="changed"
        @close="$emit('close')"
        @sendAddress="sendAddress"
        @toggleLoading="toggleLoading"
        @toggleDisabled="toggleDisabled"
      />
      <v-layout>
        <v-flex sm12 md6 lg2 class="ml-4 mt-4" v-if="orderType == 'Business Fibre'">
          <v-combobox
            v-model="speed"
            label="* Select Desired Speed"
            :items="speedType"
            @change="resetValidationSpeed($event)"
          ></v-combobox>
        </v-flex>
      </v-layout>
      <UtilityFinderResult
        ref="qualificationResult"
        :show-buttons="true"
        :show-loc-id-input="showLocIdInput"
        :query-address="queryAddress"
        :address-state="addressState"
        :hide-other-buttons="false"
        :with-data="true"
        :selected="selected"
        :hasMatch="hasMatch"
        :speed="speed"
        @showResultSection="assignResult"
        @toggleLoading="toggleLoading"
      ></UtilityFinderResult>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          v-if="
            $refs.qualificationForm && orderType == 'Business Fibre'
          "
          :disabled="disabled || !address"
          large
          @click="sendSQ"
        >
          Send SQ
        </v-btn>
        <v-btn color="light-grey" large @click="closeDialog">Close</v-btn>
      </v-card-actions>
      <v-snackbar v-model="snackbar" :timeout="3000" color="green">
        Address Validated
        <v-btn flat @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    </v-card>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import UtillityServiceQualificationForm from './utility-service-qualification-form';
import UtilityFinderResult from './utility-finder-result';
const { mapGetters: mapSQGetters } = createNamespacedHelpers(`orders/sq`);
const { mapActions: mapSQAddressActions } =
  createNamespacedHelpers(`orders/sqAddress`);
const { mapGetters: mapSQAddressGetters } =
  createNamespacedHelpers(`orders/sqAddress`);
const { mapActions: mapSQActions } = createNamespacedHelpers(`orders/sq`);
const { mapGetters: mapFeatureFlagGetters } = createNamespacedHelpers(`orders/featureFlag`);

export default {
  components: {
    UtillityServiceQualificationForm,
    UtilityFinderResult,
  },
  data: () => ({
    showNewOrder: false,
    queryAddress: [],
    addressState: '',
    streetAddress: '',
    populatedAddress: {},
    sqNbnProcessing: false,
    sq5GProcessing: false,
    showLocIdInput: false,
    id: '',
    selected: 'Physical Address',
    isFeatureOn: false,
    loading: false,
    disabled: true,
    address: null,
    hasMatch: true,
    snackbar: false,
    speedType: ['100/100','200/200','250/250','500/500','1000/1000', 'Other'],
    speed: '100/100',
  }),
  computed: {
    ...mapSQGetters(['orderType', 'locationID']),
    ...mapFeatureFlagGetters(['allFlags']),
  },
  mounted() {},
  methods: {
    ...mapSQActions([
      'reset5gSq',
      'setLocationID',
      'serviceQualification5G',
      'setFormattedSQResult',
      'serviceQualificationNbn',
      'setFormattedNbnSQResult',
      'resetProductType',
      'resetNtdId',
      'resetCpiId',
      'resetFormattedSqNbnResult',
      'setOrderType',
    ]),
    closeNewOrder() {
      let vm = this;
      vm.showNewOrder = false;
    },
    resetValidationSpeed(event) {
      let vm = this;
      vm.latitude = '';
      vm.longitude = '';
      vm.streetAddress = '';
      vm.gnafId = '';
      vm.selected = event;
      vm.result = {
        suburb: '',
        state: '',
        postCode: '',
        streetAddress: '',
      };
      vm.setLocationID('');
      vm.id = '';
      vm.queryAddress = [];
      vm.reset5gSq();
    },
    showResultSection(details) {
      let vm = this;
      if (vm.orderType !== 'Business Fibre') {
        if (vm.selected === 'Physical Address' && vm.orderType === 'nbn') {
          vm.hasMatch = details.result && details.result.length > 0;
        }

        if (vm.orderType === 'nbn') {
          vm.queryAddress = details.queryAddress;
          vm.streetAddress = details.streetAddress;
          vm.populatedAddress = details.populatedAddress;

          if (
            details.queryAddress.length === 1 &&
            details.queryAddress.length !== 0
          ) {
            vm.showLocIdInput = false;
            vm.setLocationID(vm.queryAddress[0].locationId);

            var payload = {
              addressCheckMethodType: 'NBN_LOCATION_ID',
              addressValue: {
                LocationId: vm.queryAddress[0].locationId,
              },
            };
            vm.loading = true;
            vm.serviceQualificationNbn(payload).then((data) => {
              vm.loading = true;
              vm.setFormattedNbnSQResult(data.data);
              vm.$refs.qualificationResult.result = data.data;
              vm.$refs.qualificationResult.showSqResult = true;
            })
            .finally(() => {
              vm.loading = false;
            });
          } else vm.showLocIdInput = true;
        } else {
          this.$nextTick(() => {
            vm.$refs.qualificationResult.showSqResult5G = true;
          });
        }
      }
    },
    assignResult(details) {
      let vm = this;
      if (vm.$refs.qualificationResult !== undefined) {
        vm.$refs.qualificationResult.showSqResult = false;
      }

      if (
        details.sq.siteRestriction.serviceabilityStatus === 'Rejected' ||
        details.sq.siteRestriction.supportingTechnology
          .primaryAccessTechnology === 'Satellite'
      ) {
        vm.$refs.qualificationResult.showSqResult = true;
        return;
      }
      
      if (details.queryAddress != null) {
        vm.queryAddress = details.queryAddress;
        vm.showLocIdInput = true;
      } else {
        vm.$refs.qualificationResult.showSqResult = true;
        vm.$refs.qualificationResult.result = details;
        vm.$refs.qualificationResult.setFormattedNbnSQResult(details);
      }

      if(vm.orderType == 'Business Fibre') {
        vm.address = details.address;
        vm.disabled = false;
      }
    },
    toggleInput(state) {
      let vm = this;
      vm.showLocIdInput = state;
      vm.$refs.qualificationResult.hideResult();
    },
    changed(selected) {
      let vm = this;
      vm.showLocIdInput = false;
      vm.$refs.qualificationResult.showSqResult = false;
      vm.$refs.qualificationResult.showSqResult5G = false;
      vm.$refs.qualificationResult.hideResult();
      vm.queryAddress = [];
      vm.hasMatch = true;
      vm.address = '';
      if (selected !== undefined) {
        vm.selected = selected;
      }
    },
    toggleLoading(state) {
      this.loading = state;
    },
    sendSQ() {
      let vm = this;
      let desired_speed = vm.speed;
      
      if(vm.selected == 'Location ID') {
        var locID_payload = {
            formatted_address: vm.address.formattedAddress,
            services: ["Business Fibre"]
        }
        vm.$emit('sendAddress', locID_payload, desired_speed);
      } else {
        vm.$emit('sendAddress', vm.address, desired_speed);
      }
    },
    sendAddress(address, desired_speed) {
      let vm = this;
      vm.address = address;
      vm.speed = desired_speed;
      vm.snackbar = true;
      vm.disabled = false;
    },
    closeDialog() {
      this.$refs.qualificationForm.services = 'nbn';
      this.$refs.qualificationResult.showSqResult = false;
      // this.resetProductType();
      // this.resetNtdId();
      // this.resetCpiId();
      this.resetFormattedSqNbnResult();
      this.$emit('close');
    },
    toggleDisabled(val) {
      this.disabled = val;
    },
  },
};
</script>
